/* eslint-disable import/no-anonymous-default-export */
import NewSupplymintLogo from "./NewSupplymintLogo.svg";
import VendorSupplymintLogo from "./VendorSupplymintLogo.svg";
import CustomerSupplymintLogo from "./CustomerSupplymintLogo.svg";
import MenuHomeIcon from "./MenuHomeIcon.svg";
import { ReactComponent as DigiArsMenuIcon } from "./DigiArsMenuIcon.svg";
import { ReactComponent as DigiVendorMenuIcon } from "./DigiVendorMenuIcon.svg";
import { ReactComponent as EntCatalogueMenuIcon } from "./EntCatalogueMenuIcon.svg";
import { ReactComponent as SalesManagementMenuIcon } from "./SalesManagementMenuIcon.svg";
import { ReactComponent as MasterDataMenuIcon } from "./MasterDataMenuIcon.svg";
import { ReactComponent as AdminIconMenuIcon } from "./AdminIconMenuIcon.svg";
import { ReactComponent as VendorCatalogueMenuIcon } from "./VendorCatalogueMenuIcon.svg";
import { ReactComponent as InvoiceManagementMenuIcon } from "./InvoiceManagementMenuIcon.svg";
import { ReactComponent as DigiProcMenuIcon } from "./DigiProcMenuIcon.svg";
import { ReactComponent as ReportsAnalyticsMenuIcon } from "./ReportsAnalyticsMenuIcon.svg";
import { ReactComponent as SuperAdminMenuIcon } from "./SuperAdminMenuIcon.svg";
import { ReactComponent as DigiArsMenuIconFilled } from "./DigiArsMenuIconFilled.svg";
import { ReactComponent as DigiVendorMenuIconFilled } from "./DigiVendorMenuIconFilled.svg";
import { ReactComponent as EntCatalogueMenuIconFilled } from "./EntCatalogueMenuIconFilled.svg";
import { ReactComponent as SalesManagementMenuIconFilled } from "./SalesManagementMenuIconFilled.svg";
import { ReactComponent as MasterDataMenuIconFilled } from "./MasterDataMenuIconFilled.svg";
import { ReactComponent as AdminIconMenuIconFilled } from "./AdminIconMenuIconFilled.svg";
import { ReactComponent as InvoiceManagementMenuIconFilled } from "./InvoiceManagementMenuIconFilled.svg";
import { ReactComponent as SuperAdminMenuIconFilled } from "./SuperAdminMenuIconFilled.svg";
import { ReactComponent as DigiProcMenuIconFilled } from "./DigiProcMenuIconFilled.svg";
import { ReactComponent as ReportsAnalyticsMenuIconFilled } from "./ReportsAnalyticsMenuIconFilled.svg";
import { ReactComponent as RightArrowMenuIcon } from "./RightArrowMenuIcon.svg";
import { ReactComponent as GlobalSearchIcon } from "./GlobalSearchIcon.svg";
import { ReactComponent as DangerIcon } from "./danger.svg"
import { ReactComponent as ModalCloseIcon } from "./ModalCloseIcon.svg";
import { ReactComponent as SelectedItemIcon } from "./SelectedItemIcon.svg";
import { ReactComponent as DeselectedItemIcon } from "./DeselectedItemIcon.svg";
import { ReactComponent as GlobalSearchArrowIcon } from "./GlobalSearchArrowIcon.svg";
import { ReactComponent as HeaderHelpMenuIcon } from "./HeaderHelpMenuIcon.svg";
import { ReactComponent as HeaderDataExportIcon } from "./HeaderDataExportIcon.svg";
import { ReactComponent as HeaderNotificationsIcon } from "./HeaderNotificationsIcon.svg";
import { ReactComponent as DataExportFileIcon } from "./DataExportFileIcon.svg";
import { ReactComponent as DataExportFileIconNew } from "./DataExportFileIconNew.svg";
import { ReactComponent as DataExportDownloadActiveIcon } from "./DataExportDownloadActiveIcon.svg";
import { ReactComponent as DataExportDownloadDisabledIcon } from "./DataExportDownloadDisabledIcon.svg";
import { ReactComponent as DataExportCancelActiveIcon } from "./DataExportCancelActiveIcon.svg";
import { ReactComponent as DataExportCancelDisabledIcon } from "./DataExportCancelDisabledIcon.svg";
import { ReactComponent as NotificationMenuIcon } from "./NotificationMenuIcon.svg";
import { ReactComponent as ProfileLogoutIcon } from "./ProfileLogoutIcon.svg";
import { ReactComponent as BackArrowIcon } from "./BackArrowIcon.svg";
import { ReactComponent as BackArrowIcon2 } from "./BackArrowIcon2.svg";
import { ReactComponent as CopyIcon } from "./copyIcon.svg";
import { ReactComponent as CopyIconWhite } from "./copyIconWhite.svg";
import { ReactComponent as NewCopyIcon } from "./NewCopyIcon.svg";
import { ReactComponent as GreenDotWatchIcon } from "./GreenDotWatchIcon.svg";
import { ReactComponent as RedDotWatchIcon } from "./RedDotWatchIcon.svg";
import { ReactComponent as GreenDotActive } from "./GreenDotActive.svg";
import { ReactComponent as GreyDotInactive } from "./GreyDotInactive.svg";
import { ReactComponent as TriggerHandIcon } from "./TriggerHandIcon.svg";
import { ReactComponent as TnaIcon } from "./tnaIcon.svg";
import { ReactComponent as AttachFileBlueIcon } from "./AttachFileBlueIcon.svg";
import { ReactComponent as ReadMoreAttachIcon } from "./ReadMoreAttachIcon.svg";
import { ReactComponent as DownloadWhiteIcon } from "./DownloadWhiteIcon.svg";
import { ReactComponent as DownloadPdf } from "./downloadpdf.svg";
import { ReactComponent as DownloadPdf1 } from "./DownloadPdf1.svg";
import { ReactComponent as ErrorIconNew } from "./errorIconNew.svg";
import { ReactComponent as SiteMappingSVG1 } from "./SiteToSiteMappingSVG1.svg";
import { ReactComponent as SearchIcon } from "./searchicon.svg";
import { ReactComponent as NewSearchIcon } from "./newSearchicon.svg";
import { ReactComponent as SearchIconDark } from "./SearchIconDark.svg";
import { ReactComponent as AddGreenIcon } from "./AddGreenIcon.svg";
import { ReactComponent as DeleteIcon } from './DeleteIcon.svg'
import { ReactComponent as NoHeader } from "./no-header.svg";
import { ReactComponent as CircleTick } from "./circle-white-tick.svg";
import { ReactComponent as CircleTickFilledWhite } from "./CircleTickFilledWhite.svg";
import { ReactComponent as AdhocSvg1 } from "./adhocSVG1.svg";
import { ReactComponent as FileClock } from "./fileClock.svg";
import { ReactComponent as CustomUploadSvg1 } from "./customUploadSvg1.svg";
import { ReactComponent as WarehouseIcon } from './WarehouseIcon.svg';
import { ReactComponent as WarehouseIcon2 } from './WarehouseIcon2.svg';
import { ReactComponent as WarehouseIconBlue2 } from './WarehouseIconBlue2.svg';
import { ReactComponent as StoreReplenishmentIcon } from './StoreReplenishmentIcon.svg'
import { ReactComponent as StoreReplenishmentIcon2 } from './StoreReplenishmentIcon2.svg'
import { ReactComponent as StoreReplenishmentIconBlue2 } from './StoreReplenishmentIconBlue2.svg'
import { ReactComponent as AutoPurchaseReplenishmentIcon } from './AutoPurcahseReplenishmentIcon.svg'
import { ReactComponent as AutoPurchaseReplenishmentIcon2 } from './AutoPurcahseReplenishmentIcon2.svg'
import { ReactComponent as AutoPurchaseReplenishmentIconBlue2 } from './AutoPurcahseReplenishmentIconBlue2.svg'
import { ReactComponent as WarehouseIconClipped } from './WarehouseIconClipped.svg'
import { ReactComponent as WarehouseIconBlueClipped } from './WarehouseIconBlueClipped.svg'
import { ReactComponent as StoreReplenishmentIconClipped } from './StoreReplenishmentIconClipped.svg'
import { ReactComponent as StoreReplenishmentIconBlueClipped } from './StoreReplenishmentIconBlueClipped.svg'
import { ReactComponent as AutoPurcahseReplenishmentIconClipped } from './AutoPurcahseReplenishmentIconClipped.svg'
import { ReactComponent as AutoPurcahseReplenishmentIconBlueClipped } from './AutoPurcahseReplenishmentIconBlueClipped.svg'
import { ReactComponent as PrevIcon } from "./prevIcon.svg";
import { ReactComponent as NextIcon } from "./nextIcon.svg";
import { ReactComponent as PlusIcon } from "./plusIcon.svg";
import { ReactComponent as PlusIconBlack } from "./PlusIconBlack.svg";
import { ReactComponent as AddIcon } from "./addIcon.svg";
import { ReactComponent as ExpFilterIcon } from "./ExpFilterIcon.svg";
import { ReactComponent as GCExplanationIon } from "./GCExplanationIon.svg";
import { ReactComponent as ClearSearch } from "./clearSearch.svg";
import { ReactComponent as JobRunFailedIcon } from './JobRunFailedIcon.svg'
import { ReactComponent as JobRunSuccessIcon } from "./JobRunSuccessIcon.svg";
import { ReactComponent as WarningYellowIcon } from './WarningYellowIcon.svg'
import { ReactComponent as WarningRedIcon } from './WarningRedIcon.svg'
import { ReactComponent as OnboardingWarningIcon } from './OnboardingWarningIcon.svg'
import { ReactComponent as EmailResendIcon } from './EmailResendIcon.svg'
import { ReactComponent as AddMappingPlusIcon } from './AddMappingPlusIcon.svg'
import { ReactComponent as VendorRedirectIcon } from './VendorRedirectIcon.svg'
import { ReactComponent as TGRedirectIcon } from './TGRedirection.svg'
import { ReactComponent as LogSearchIcon } from './LogSearch.svg'
import { ReactComponent as RightArrow1 } from './RightArrow1.svg'
import { ReactComponent as RightArrowThin } from './RightArrowThin.svg'
import { ReactComponent as RightArrow2 } from './RightArrow2.svg'
import { ReactComponent as LogIcon } from './LogIcon.svg'
import { ReactComponent as EyeIcon } from './eye.svg'
import { ReactComponent as DownArrowNew } from './downArrowNew.svg'
import { ReactComponent as DownArrowWhite } from './downArrowWhite.svg'
import { ReactComponent as RightArrowNewGreen } from './RightArrowNewGreen.svg'
import { ReactComponent as DownArrowFilled } from './DownArrowFilled.svg'
import { ReactComponent as DownArrowFilledGrey } from './DownArrowFilledGrey.svg'
import { ReactComponent as RefreshIcon } from './Refresh.svg'
import { ReactComponent as ConfirmationModalImg } from './confirmationModalImg.svg'
import { ReactComponent as NoDataFound } from './NoDataFound.svg'
import { ReactComponent as NewNoDataFound } from './NewNoDataFound.svg'
import { ReactComponent as EditIcon } from './editicon.svg'
import { ReactComponent as TGEditIcon } from './TGEditIcon.svg'
import { ReactComponent as UploadImg } from './uploadImg.svg'
import { ReactComponent as NoJobsFound } from './NoJobsFound.svg'
import { ReactComponent as BCRightArrow } from './BCRightArrow.svg'
import { ReactComponent as ReloadIcon } from './reload.svg'
import { ReactComponent as PinnedIcon } from './PinnedIcon.svg'
import { ReactComponent as UnpinnedIcon } from './UnpinnedIcon.svg'
import { ReactComponent as GreenTick } from './GreenTick.svg'
import { ReactComponent as GreenCircledGreenTick } from './GreenCircledGreenTick.svg'
import { ReactComponent as ImageIcon } from './ImageIcon.svg'
import { ReactComponent as BannerImageIcon } from './BannerImageIcon.svg'
import { ReactComponent as ArsPendindIcon } from './sPending.svg'
import { ReactComponent as ArsApprovedIcon } from './arsdApproved.svg'
import { ReactComponent as ArsRejectedIcon } from './arsdrejected.svg'
import { ReactComponent as ArsDFailedIcon } from './arsdFailedIcon.svg'
import { ReactComponent as FileShareIcon } from './FileShareIcon.svg'
import { ReactComponent as DownloadContentIcon } from './DownloadContentIcon.svg'
import { ReactComponent as TickGreenIcon } from './TickGreenIcon.svg'
import { ReactComponent as CrossRedIcon } from './CrossRedIcon.svg'
import { ReactComponent as CreateNewTicketIcon } from './CreateNewTicketIcon.svg'
import { ReactComponent as SortingIcon } from './HeaderFilter.svg'
import { ReactComponent as UploadExcelIcon } from './UploadExcelIcon.svg'
import { ReactComponent as DownloadExcelTemplateGreenIcon } from './DownloadExcelTemplateGreenIcon.svg'
import { ReactComponent as VendorRedirectIconWhite } from './VendorRedirectIconWhite.svg'
import { ReactComponent as SummaryInfoIcon } from './SummaryInfoIcon.svg'
import { ReactComponent as SettingIcon } from './SettingIcon.svg';
import { ReactComponent as ArsHold } from './arsHold.svg';
import { ReactComponent as ArsDraft } from './arsUnauthorized.svg';
import { ReactComponent as RupeeIcon } from './RupeeIcon.svg';
import { ReactComponent as CrossIcon } from './CrossIcon.svg';
import { ReactComponent as DownArrow } from './downArrow.svg';
import { ReactComponent as NoImgFound } from './NoImgFound.svg';
import { ReactComponent as BagIcon } from './BagIcon.svg';
import { ReactComponent as ListViewIcon } from './ListViewIcon.svg';
import { ReactComponent as GridViewIcon } from './GridViewIcon.svg';
import { ReactComponent as NewTicket } from './CreateNewTicketIcon.svg';
import { ReactComponent as HelpNewTicket } from './HelpTicketIcon.svg';
import { ReactComponent as AllTicket } from './AllTicketIcon.svg';
import { ReactComponent as HelpIcon } from './HelpIcon.svg';
import { ReactComponent as VideoIcon } from './VideoIcon.svg';
import { ReactComponent as KeyboardShortcut } from './KeyboardShortcut.svg';
import { ReactComponent as replayAppTour } from './replayAppTour.svg';
import { ReactComponent as EscalationMatrix } from './EscalationMatrix.svg';
import { ReactComponent as SupportDoc } from './SupportDoc.svg';
import { ReactComponent as DownloadDocumentsIcon } from './DownloadDocumentsIcon.svg'
import { ReactComponent as BagEdit } from './BagEdit.svg';
import { ReactComponent as ArrowUpIcon } from './arrowUp.svg';
import { ReactComponent as DragDropIcon } from './dragedrop.svg';
import { ReactComponent as PendingQcIcon } from './PendingQcIcon.svg'
import { ReactComponent as ChatIconTableComponent } from './chat_Icon.svg'
import { ReactComponent as ScanBarcodeIcon } from './ScanBarcodeIcon.svg'
import { ReactComponent as ErrorIcon } from './ErrorIcon.svg'
import { ReactComponent as UploadIcon } from './UploadIcon.svg'
import { ReactComponent as UploadIconNew } from './UploadIconNew.svg'
import { ReactComponent as CaptureIcon } from './CaptureIcon.svg'
import { ReactComponent as LeftArrow } from './LeftArrow.svg'
import { ReactComponent as RightArrowBlue } from './RightArrowBlue.svg'
import { ReactComponent as CreatePlusIcon } from './CreatePlusIcon.svg'
import { ReactComponent as Minus } from './Minus.svg'
import { ReactComponent as MinusIconBlack } from './MinusIconBlack.svg'
import { ReactComponent as Plus } from './Plus.svg'
import { ReactComponent as NoProductFound } from './NoProductFound.svg'
import { ReactComponent as Tick } from './Tick.svg'
import { ReactComponent as Check } from './Check.svg'
import { ReactComponent as MatrixView } from './matrixView.svg'
import { ReactComponent as DeleteNew } from './DeleteNew.svg'
import { ReactComponent as CustomerIcon } from './CustomerIcon.svg'
import { ReactComponent as DeliveryLocation } from './DeliveryLocation.svg'
import { ReactComponent as ScanIcon } from './ScanIcon.svg'
import { ReactComponent as HeaderDeleteIcon } from './HeaderDeleteIcon.svg'
import { ReactComponent as TableEyeIcon } from './TableEyeIcon.svg'
import { ReactComponent as TableEditIcon } from './TableEditIcon.svg'
import { ReactComponent as ExpandedTableIcon } from './ExpandedTableIcon.svg'
import { ReactComponent as NotExpandedTableIcon } from './NotExpandedTableIcon.svg'
import { ReactComponent as SettingIconNew } from './SettingIconNew.svg'
import { ReactComponent as SupplymintRIcon } from './AuthBackgroundIcon.svg';
import { ReactComponent as SupportIcon } from './SupportIcon.svg'
import { ReactComponent as EmailReport } from './EmailReport.svg'
import { ReactComponent as ExportToExcel } from './ExportToExcel.svg'
import { ReactComponent as BreadcrumbSortingIcon } from "./BreadcrumbSortingIcon.svg";
import { ReactComponent as PasswordEyeIcon } from './PasswordEyeIcon.svg'
import { ReactComponent as PasswordEyeIconSmall } from './PasswordEyeIconSmall.svg'
import { ReactComponent as PasswordEyeDisabledIcon } from './PasswordEyeDisabledIcon.svg'
import { ReactComponent as SignInBadgeIcon } from './SignInBadgeIcon.svg'
import { ReactComponent as PasswordLockIcon } from './PasswordLockIcon.svg'
import { ReactComponent as PasswordCheckCircle } from './PasswordCheckCircle.svg'
import { ReactComponent as ProfileFaceIcon } from './ProfileFaceIcon.svg'
import { ReactComponent as LogoutIcon } from './LogoutIcon.svg'
import { ReactComponent as UserIcon } from './UserIcon.svg'
import { ReactComponent as DataMappingIcon } from './DataMappingIcon.svg'
import { ReactComponent as PackageProducts } from './packages-product.svg'
import { ReactComponent as SiteMappingData } from './site-data.svg'
import { ReactComponent as VendorMappingData } from './vendor-data.svg'
import { ReactComponent as ManagementData } from './management.svg'
import { ReactComponent as LoginStripIcon } from './LoginStripIcon.svg'
import { ReactComponent as Remark } from "./Remark.svg";
import { ReactComponent as AddComentEnterIcon } from "./AddComentEnterIcon.svg";
import { ReactComponent as EmailTranscriptIcon } from "./EmailTranscriptIcon.svg";
import { ReactComponent as MoverIcon } from "./MoverIcon.svg";
import { ReactComponent as NoScanIcon } from "./NoScanIcon.svg";
import { ReactComponent as CollapesIcon } from "./CollapesIcon.svg";
import { ReactComponent as ProcAddIcon } from "./ProcAddIcon.svg";
import { ReactComponent as ProcAddRow } from "./ProcAddRow.svg";
import { ReactComponent as ProcMoreBtn } from "./ProcMoreBtn.svg";
import { ReactComponent as ProcDeleteIcon } from "./ProcDeleteIcon.svg";
import { ReactComponent as ProcCopyIcon } from "./ProcCopyIcon.svg";
import { ReactComponent as ErrorWarning } from "./ErrorWarning.svg";
import { ReactComponent as CopyRightIcon } from "./CopyRightIcon.svg";
import { ReactComponent as MobileOTPIcon } from "./MobileOTPIcon.svg";
import { ReactComponent as EmailOTPIcon } from "./EmailOTPIcon.svg";
import { ReactComponent as ProfileSettingIcon } from "./ProfileSettingIcon.svg";
import { ReactComponent as ProfileOrgIcon } from "./ProfileOrgIcon.svg";
import { ReactComponent as ImgPrevIcon } from "./ImgPrevIcon.svg";
import { ReactComponent as ImgNextIcon } from "./ImgNextIcon.svg";
import { ReactComponent as ExpandRow } from "./ExpandRow.svg";
import { ReactComponent as DownArrowSmall } from "./DownArrowSmall.svg";
import { ReactComponent as HandDollarSvg } from "./HandDollar.svg";
import { ReactComponent as CommentSvg } from "./Comment.svg";
import { ReactComponent as RedYellowGreenDot } from './RedYellowGreenDot.svg'
import { ReactComponent as NoCommentSvg } from "./nocomment.svg";
import { ReactComponent as UnapprovedTag } from "./UnapprovedTag.svg";
import { ReactComponent as ExpandedConfigTableHeader } from './ExpandedConfigTableHeader.svg'
import { ReactComponent as UnexpandedConfigTableHeader } from './UnexpandedConfigTableHeader.svg'
import { ReactComponent as WebIcon } from './Webicon.svg'
import { ReactComponent as RemarkCancelIocn } from './RemarkCancel.svg'
import { ReactComponent as OrgLogoGeneric } from './org-logo-generic.svg'
import { ReactComponent as NoLogoIcon } from './NoLogoIcon.svg'
import { ReactComponent as EmptyBoxNew } from './empty-box-new.svg'
import { ReactComponent as ProcChooseFileIcon } from './ProcChooseFileIcon.svg'
import { ReactComponent as RightArrowWhite } from './RightArrowWhite.svg'
import { ReactComponent as TableHeader } from './TableHeader.svg'
import { ReactComponent as DocumentFormat } from './DocumentFormat.svg'
import { ReactComponent as APIIntegration } from './APIIntegration.svg'
import { ReactComponent as DataManagement } from './DataManagement.svg'
import { ReactComponent as GeneralSetting } from './GeneralSetting.svg'
import { ReactComponent as WorkflowSetting } from './WorkflowSetting.svg'
import { ReactComponent as FormSetting } from './FormSetting.svg'
import { ReactComponent as MultiLevelApproval } from './MultiLevelApproval.svg'
import { ReactComponent as DataSetting } from './DataSetting.svg'
import { ReactComponent as OrganizationData } from './OrganizationData.svg'
import { ReactComponent as BarcodeProfile } from './BarcodeProfile.svg'
import { ReactComponent as ReplenishmentSetting } from './ReplenishmentSetting.svg'
import { ReactComponent as DropdownField } from './DropdownField.svg'
import { ReactComponent as Training } from './Training.svg'
import { ReactComponent as Announcement } from './Announcement.svg'
import { ReactComponent as SystemMaintenance } from './SystemMaintenance.svg'
import { ReactComponent as GCNotification } from './GCNotification.svg'
import { ReactComponent as InfoIcon } from './InfoIcon.svg'
import { ReactComponent as TableComponentDownloadDocIcon } from './TableComponentDownloadDocIcon.svg'
import { ReactComponent as PdfDownloadDocumentIcon } from './PdfDownloadDocumentIcon.svg'
import { ReactComponent as ImageThumbnail } from './image-thumbnail.svg'
import { ReactComponent as CatalogueImageThumbnail } from './CatalogueImageThumbnail.svg'
import { ReactComponent as DraftFileIcon } from './DraftFile.svg'
import { ReactComponent as InfoWhiteIcon } from './infoWhite.svg'
import { ReactComponent as BlueInfoIcon } from './BlueInfoIcon.svg'
import { ReactComponent as TableConfigDefault } from './TableConfigDefault.svg'
import { ReactComponent as GCFilterIcon } from './GCFilterIcon.svg'
import { ReactComponent as BlueDownloadIcon } from './BlueDownloadIcon.svg'
import { ReactComponent as DelayIcon } from './DelayedIcon.svg'
import { ReactComponent as ArrowReviewSvg } from './ArrowReview.svg'
import { ReactComponent as FilePlusIcon } from './FilePlusIcon.svg'
import { ReactComponent as Threedot } from './Threedot.svg'
import { ReactComponent as TGImgIcon } from './TGImgIcon.svg'
import { ReactComponent as TGVideoIcon } from './TGVideoIcon.svg'
import { ReactComponent as TGPdfIcon } from './TGPdfIcon.svg'
import { ReactComponent as FilterPinned } from './FilterPinned.svg'
import { ReactComponent as GRCSuccessIcon } from './GRCSuccessIcon.svg'
import { ReactComponent as RightArrowExpand } from './RightArrowExpand.svg'
import { ReactComponent as RightBigArrow } from './RightBigArrow.svg'
import { ReactComponent as RightArrowExpand2 } from './RightArrowExpand2.svg'
import { ReactComponent as SupplierBasicDetailsIcon } from './SupplierBasicDetailsIcon.svg'
import { ReactComponent as FinanceIcon } from './FinanceIcon.svg'
import { ReactComponent as DocumentMediaIcon } from './DocumentMedia.svg'
import { ReactComponent as CompliancesIcon } from './CompliancesIcon.svg'
import { ReactComponent as ReportDownloadIcon } from './ReportDownloadIcon.svg'
import { ReactComponent as ScheduledJObIcon } from './ScheduledJObIcon.svg'
import { ReactComponent as GCUploadIcon } from './GCUploadIcon.svg'
import { ReactComponent as ApproveCircleTick } from './ApproveCircleTick.svg'
import { ReactComponent as UnapproveCircleTick } from './UnapproveCircleTick.svg'
import { ReactComponent as AnnouncementAlert } from './AnnouncementAlert.svg'
import { ReactComponent as AnnouncementGreenAlert } from './AnnouncementGreenAlert.svg'
import { ReactComponent as NoAnnouncementAlert } from './NoAnnouncementAlert.svg'
import { ReactComponent as RightArrowGrey } from './RightArrowGrey.svg'
import { ReactComponent as InfoYellow } from './InfoYellow.svg'
import { ReactComponent as EditNewIcon } from './EditNewIcon.svg'
import { ReactComponent as WHBlueTick } from './WHBlueTick.svg'
import { ReactComponent as Apparels } from './Apparels.svg'
import { ReactComponent as Fabric } from './Fabric.svg'
import { ReactComponent as FashionAccessories } from './FashionAccessories.svg'
import { ReactComponent as HomeFurnishing } from './HomeFurnishing.svg'
import { ReactComponent as EnterInputIcon } from './EnterInputIcon.svg'
import { ReactComponent as Battick } from './Battick.svg'
import { ReactComponent as Dyeing } from './Dyeing.svg'
import { ReactComponent as Embroidery } from './Embroidery.svg'
import { ReactComponent as KaajButton } from './KaajButton.svg'
import { ReactComponent as Printing } from './Printing.svg'
import { ReactComponent as TestingFacilities } from './TestingFacilities.svg'
import { ReactComponent as Washing } from './Washing.svg'
import { ReactComponent as YarnSpinning } from './YarnSpinning.svg'
import { ReactComponent as OnSupplierPayroll } from './OnSupplierPayroll.svg'
import { ReactComponent as ThirdPartyContracts } from './ThirdPartyContracts.svg'
import { ReactComponent as VOStrongIcon } from './VOStrongIcon.svg'
import { ReactComponent as VOWeakIcon } from './VOWeakIcon.svg'
import { ReactComponent as VOModerateIcon } from './VOModerateIcon.svg'
import { ReactComponent as TimeLeftIcon } from './TimeLeftIcon.svg'
import { ReactComponent as BlackHeart } from './BlackHeart.svg'
import { ReactComponent as GreyHeart } from './GreyHeart.svg'
import { ReactComponent as StepCompletedGreenTick } from './StepCompletedGreenTick.svg'
import { ReactComponent as StepCompletedGreyTick } from './StepCompletedGreyTick.svg'
import { ReactComponent as StepSeparationROd } from './StepSeparationROd.svg'
import { ReactComponent as ImgExpandIcon } from './ImgExpandIcon.svg'
import { ReactComponent as Configuration } from './Configuration.svg'
import { ReactComponent as closeRedNew } from './closeRedNew.svg'
import { ReactComponent as addGreen } from './add-green.svg'
import { ReactComponent as FilePlusGreenIcon } from './data-setting-plus-green-icon.svg'
import { ReactComponent as SummaryTransferOrderIcon } from './SummaryTransferOrderIcon.svg'
import { ReactComponent as NewDownloadIcon } from './NewDownloadIcon.svg'
import { ReactComponent as DownloadIcon } from './DownloadIcon.svg'
import { ReactComponent as PhoneIcon } from './PhoneIcon.svg'
import { ReactComponent as Calender } from './calenderNew2.svg'
import { ReactComponent as SubscriptionExpired } from './SubscriptionExpired.svg'
import { ReactComponent as ModuleIcon } from './ModuleIcon.svg'
import { ReactComponent as VerifiedIcon } from './verified.svg'
import { ReactComponent as FlagWithCountryCodeIcon } from './FlagWithCountryCode.svg'
import { ReactComponent as InfoIconNew } from './InfoIconNew.svg'
import { ReactComponent as PASSWORD } from './password.svg'
import {ReactComponent as Transpose} from './transpose.svg'
import { ReactComponent as BOTH } from './bothLogin.svg'
import { ReactComponent as MOBILE } from './mobileLogin.svg'
import { ReactComponent as ConfirmIdentityIcon } from './ConfirmIdentityIcon.svg'
import { ReactComponent as VendorHoldIcon } from './VendorHold.svg'
import { ReactComponent as WifiNotFoundIcon } from './NoWifiIcon.svg';
import { ReactComponent as WifiEnabledIcon } from './WifiEnabledicon.svg'
import { ReactComponent as UpgradSoft } from './upgradSoft.svg'
import { ReactComponent as PurchaseTerm } from './PurchaseTerm.svg'
import { ReactComponent as ZipAttack } from './zipAttack.svg'
import { ReactComponent as WorkLogsIcon } from './WorkLogsIcon.svg'
import { ReactComponent as DefaultReportIcon } from './DefaultReportIcon.svg'
import { ReactComponent as SendIcon } from './SendIcon.svg'
import { ReactComponent as WechatIcon } from './WechatIcon.svg'
import { ReactComponent as DummyQRCode } from './DummyQRCode.svg'
import { ReactComponent as DesktopWarningIcon } from './DesktopWarningIcon.svg'
import { ReactComponent as MacIcon } from './MacIcon.svg'
import { ReactComponent as WindowsIcon } from './WindowsIcon.svg'
import { ReactComponent as PlaneIconYellow } from './PlaneIconYellow.svg'
import { ReactComponent as CelebrationPopperIcon } from './CelebrationPopperIcon.svg'
import { ReactComponent as NewPdfIcon } from './NewPdfIcon.svg'
import { ReactComponent as SessionExpiredIcon } from './session-expired.svg'
import { ReactComponent as ExcelFileIcon } from './ExcelFileIcon.svg'
import { ReactComponent as ExcelFileIcon2 } from './ExcelFileIcon2.svg'
import { ReactComponent as WordFileIcon } from './WordFileIcon.svg'
import { ReactComponent as ChineseLangIcon } from './ChineseLangIcon.svg'
import { ReactComponent as WechatIcon2 } from './WechatIcon2.svg'
import { ReactComponent as KeyIcon } from './KeyIcon.svg'
import { ReactComponent as UsersLimitReached } from './UsersLimitReached.svg'
import { ReactComponent as NoDataFoundNew } from './NoDataFound.svg'
import { ReactComponent as NoPageAvailable } from './NoPageAvailable.svg'
import { ReactComponent as SiteLimitReached } from './SiteLimitReached.svg'
import { ReactComponent as SuccessIcon } from './SuccessIcon.svg'
import { ReactComponent as SaveFilterWarning } from './SaveFilteWarningIcon.svg'
import { ReactComponent as FabricIcon } from './FabricIcon.svg'
import { ReactComponent as FeedbackIcon } from './FeedbackIcon.svg'
import { ReactComponent as thirdPartyIcon } from './thirdPartyIcon.svg'
import { ReactComponent as MoneyRating1 } from './MoneyRating1.svg'
import { ReactComponent as MoneyRating2 } from './MoneyRating2.svg'
import { ReactComponent as MoneyRating3 } from './MoneyRating3.svg'
import { ReactComponent as MoneyRating4 } from './MoneyRating4.svg'
import { ReactComponent as MoneyRating5 } from './MoneyRating5.svg'
import { ReactComponent as PdfFileIcon } from './PdfFileIcon.svg'
import { ReactComponent as CommentIcon } from './CommentIcon.svg'
import { ReactComponent as CopyPenIcon } from './copy-pen.svg'
import { ReactComponent as GstIcon } from './GSTIcon.svg'
import { ReactComponent as LocationIcon } from './location.svg'
import { ReactComponent as DryClean } from './dry-clean.svg'
import { ReactComponent as Bleach } from './Bleach.svg'
import { ReactComponent as TumbleDry } from './tumble-dry.svg'
import { ReactComponent as Iron } from './iron.svg'
import { ReactComponent as CelebrationColorfulPopper } from './CelebrationColorfulPopper.svg'
import { ReactComponent as InfiniteLoop } from './InfiniteLoop.svg'
import { ReactComponent as ExcelUploadTemplate } from './ExcelUploadTemplate.svg'
import { ReactComponent as EyeIcon2 } from './EyeIcon2.svg'
import { ReactComponent as productImagesCollection } from './productImagesCollection.svg'
import { ReactComponent as wallet } from './wallet.svg'
import { ReactComponent as UploadIconBlue } from './uploadIconBlue.svg'
import { ReactComponent as SortingUpArrow } from './sortingUpArrow.svg'
import { ReactComponent as PlayIcon } from './playIcon.svg'
import { ReactComponent as HomeIcon } from './homeIcon.svg'
import { ReactComponent as HomeIconFilled } from './homeIconFilled.svg'
import { ReactComponent as EmailReceived } from './emailReceived.svg'
import { ReactComponent as EmailSent } from './emailSent.svg'
import { ReactComponent as Star } from './star.svg'
import { ReactComponent as RatingEmoji1 } from './ratingEmoji1.svg'
import { ReactComponent as RatingEmoji2 } from './ratingEmoji2.svg'
import { ReactComponent as RatingEmoji3 } from './ratingEmoji3.svg'
import { ReactComponent as RatingEmoji4 } from './ratingEmoji4.svg'
import { ReactComponent as RatingEmoji5 } from './ratingEmoji5.svg'
import { ReactComponent as ThumbsUp } from './thumbsUp.svg'
import { ReactComponent as ThumbsDown } from './thumbsDown.svg'
import { ReactComponent as Collapse2 } from './collapse2.svg'
import { ReactComponent as Expand2 } from './expand2.svg'
import { ReactComponent as FilterCheck } from './filterCheck.svg'
import { ReactComponent as Upgrade } from './upgrade.svg'
import { ReactComponent as NoDocument } from './NoDocument.svg'
import { ReactComponent as CostsheetError } from './costsheetError.svg'
import { ReactComponent as SupplymintGrey } from './supplymintGrey.svg'
import { ReactComponent as FabricNotFound } from './fabricNotFound.svg'
import { ReactComponent as CheckedGreen } from './checkedGreen.svg'
import { ReactComponent as VendorIcon } from './vendorIcon.svg'
import { ReactComponent as PoAmount } from './poAmount.svg'
import { ReactComponent as DropdownSettings } from './dropdownSettings.svg'
import { ReactComponent as ItemMasterConfig } from './itemMasterConfig.svg'
import { ReactComponent as NewSearchIconWhite } from './newSearchIconWhite.svg'

// New Sidemenu Module Icons
import { ReactComponent as DashboardMenuV2 } from './dashboardMenuV2.svg'
import { ReactComponent as ProductsV2 } from './productsV2.svg'
import { ReactComponent as SalesIndentV2 } from './salesIndentV2.svg'
import { ReactComponent as PurchaseOrdersV2 } from './purchaseOrdersV2.svg'
import { ReactComponent as ShipmentsV2 } from './shipmentsV2.svg'
import { ReactComponent as LogisticsV2 } from './logisticsV2.svg'
import { ReactComponent as GrcV2 } from './grcV2.svg'
import { ReactComponent as LedgerV2 } from './ledgerV2.svg'
import { ReactComponent as ReportsAndAnalyticsV2 } from './reportsAndAnalyticsV2.svg'

import { ReactComponent as MappingsV2 } from './mappingsV2.svg'
import { ReactComponent as AssortmentV2 } from './assortmentV2.svg'
import { ReactComponent as RunReplenishmentV2 } from './runReplenishmentV2.svg'
import { ReactComponent as PlanningOrdersV2 } from './planningOrdersV2.svg'
import { ReactComponent as AdhocRequestsV2 } from './adhocRequestsV2.svg'
import { ReactComponent as HistoryV2 } from './historyV2.svg'

import { ReactComponent as QualityCheckV2 } from './qualityCheckV2.svg'
import { ReactComponent as AsnV2 } from './asnV2.svg'
import { ReactComponent as FinanceV2 } from './financeV2.svg'
import { ReactComponent as ManageV2 } from './manageV2.svg'
import { ReactComponent as BoxThree} from "./BoxThree.svg"
import { ReactComponent as FileTick} from "./FileTickPurchase.svg"

import { ReactComponent as LrProcessingV2 } from './lrProcessingV2.svg'
import { ReactComponent as GrcStatusV2 } from './grcStatusV2.svg'
import { ReactComponent as SaleOrdersV2 } from './saleOrdersV2.svg'
import { ReactComponent as DeliveryChallanV2 } from './deliveryChallanV2.svg'
import { ReactComponent as PricelistV2 } from './pricelistV2.svg'

import { ReactComponent as AdministrationV2 } from './administrationV2.svg'
import { ReactComponent as MasterDataV2 } from './masterDataV2.svg'

// Master data icons
import { ReactComponent as AgentsV2 } from './agentsV2.svg'
import { ReactComponent as SetV2 } from './setV2.svg'
import { ReactComponent as VendorsV2 } from './vendorsV2.svg'
import { ReactComponent as MailingListV2 } from './mailingListV2.svg'
import { ReactComponent as CostSheetLibraryV2 } from './costSheetLibraryV2.svg'
import { ReactComponent as ItemsV2 } from './itemsV2.svg'
import { ReactComponent as TransportersV2 } from './transportersV2.svg'
import { ReactComponent as FabricLibraryV2 } from './fabricLibraryV2.svg'
import { ReactComponent as MaterialLibraryV2 } from './materialLibraryV2.svg'
import { ReactComponent as CustomersV2 } from './customersV2.svg'
import { ReactComponent as SalesAgentsV2 } from './salesAgentsV2.svg'
import { ReactComponent as SitesV2 } from './sitesV2.svg'

// Administration icons
import { ReactComponent as ManageRolesV2 } from './manageRolesV2.svg'
import { ReactComponent as CreateRolesV2 } from './createRolesV2.svg'
import { ReactComponent as GlobalConfigurationV2 } from './globalConfigurationV2.svg'
import { ReactComponent as UserDataMappingV2 } from './userDataMappingV2.svg'
import { ReactComponent as UsersV2 } from './usersV2.svg'
import { ReactComponent as DataSyncV2 } from './dataSyncV2.svg'
import { ReactComponent as AuditLogsV2 } from './auditLogsV2.svg'
import { ReactComponent as ApiLogsV2 } from './apiLogsV2.svg'
import { ReactComponent as SystemMailsV2 } from './systemMailsV2.svg'
import { ReactComponent as RolesV2 } from './rolesV2.svg'

// Reports and Analytics icons
import { ReactComponent as ReplenishmentV2 } from './replenishmentV2.svg'
import { ReactComponent as InventoryControlV2 } from './inventoryControlV2.svg'
import { ReactComponent as AdminV2 } from './adminV2.svg'
import { ReactComponent as SalesV2 } from './salesV2.svg'
import { ReactComponent as PurchaseV2 } from './purchaseV2.svg'
import { ReactComponent as AccountingV2 } from './accountingV2.svg'
import { ReactComponent as StockV2 } from './stockV2.svg'
import { ReactComponent as ReportAnalyticsLogisticsV2 } from './reportAnalyticsLogisticsV2.svg'
import { ReactComponent as ReportAnalyticsShipmentV2 } from './reportAnalyticsShipmentV2.svg'
import { ReactComponent as ApplicationsSemiFill } from './applicationsSemiFill.svg'

import { ReactComponent as Grievance } from './grievance.svg'
import { ReactComponent as SalesForecastV2 } from './salesForecastV2.svg'
import { ReactComponent as SalesForecastFilledV2 } from './salesForecastFilledV2.svg'
import { ReactComponent as ServiceOrderV2 } from './serviceOrderV2.svg'
import { ReactComponent as ServiceOrderFilledV2 } from './serviceOrderFilledV2.svg'


// module icons
import { ReactComponent as DigiprocV2 } from './digiProcV2.svg'
import { ReactComponent as AllokatorV2 } from './allokatorV2.svg'
import { ReactComponent as DigisalesV2 } from './digisalesV2.svg'

// filled state
import { ReactComponent as DashboardMenuFilledV2 } from './dashboardMenuFilledV2.svg'
import { ReactComponent as ProductsFilledV2 } from './productsFilledV2.svg'
import { ReactComponent as SalesIndentFilledV2 } from './salesIndentFilledV2.svg'
import { ReactComponent as PurchaseOrdersFilledV2 } from './purchaseOrdersFilledV2.svg'
import { ReactComponent as ShipmentsFilledV2 } from './shipmentsFilledV2.svg'
import { ReactComponent as LogisticsFilledV2 } from './logisticsFilledV2.svg'
import { ReactComponent as GrcFilledV2 } from './grcFilledV2.svg'
import { ReactComponent as LedgerFilledV2 } from './ledgerFilledV2.svg'
import { ReactComponent as ReportsAndAnalyticsFilledV2 } from './reportsAndAnalyticsFilledV2.svg'

import { ReactComponent as MappingsFilledV2 } from './mappingsFilledV2.svg'
import { ReactComponent as AssortmentFilledV2 } from './assortmentFilledV2.svg'
import { ReactComponent as RunReplenishmentFilledV2 } from './runReplenishmentFilledV2.svg'
import { ReactComponent as PlanningOrdersFilledV2 } from './planningOrdersFilledV2.svg'
import { ReactComponent as AdhocRequestsFilledV2 } from './adhocRequestsFilledV2.svg'
import { ReactComponent as HistoryFilledV2 } from './historyFilledV2.svg'

import { ReactComponent as QualityCheckFilledV2 } from './qualityCheckFilledV2.svg'
import { ReactComponent as AsnFilledV2 } from './asnFilledV2.svg'
import { ReactComponent as FinanceFilledV2 } from './financeFilledV2.svg'
import { ReactComponent as ManageFilledV2 } from './manageFilledV2.svg'

import { ReactComponent as LrProcessingFilledV2 } from './lrProcessingFilledV2.svg'
import { ReactComponent as GrcStatusFilledV2 } from './grcStatusFilledV2.svg'
import { ReactComponent as SaleOrdersFilledV2 } from './saleOrdersFilledV2.svg'
import { ReactComponent as DeliveryChallanFilledV2 } from './deliveryChallanFilledV2.svg'
import { ReactComponent as PricelistFilledV2 } from './pricelistFilledV2.svg'
import { ReactComponent as FileBadge } from './fileBadge.svg'
import { ReactComponent as UserIn } from './userIn.svg'
import { ReactComponent as UserOut } from './userOut.svg'

// import { ReactComponent as AdministrationFilledV2 } from './administrationFilledV2.svg'
// import { ReactComponent as MasterDataFilledV2 } from './masterDataFilledV2.svg'

// Master data icons
// import { ReactComponent as AgentsFilledV2 } from './agentsFilledV2.svg'
// import { ReactComponent as SetFilledV2 } from './setFilledV2.svg'
// import { ReactComponent as VendorsFilledV2 } from './vendorsFilledV2.svg'
// import { ReactComponent as MailingListFilledV2 } from './mailingListFilledV2.svg'
// import { ReactComponent as CostSheetLibraryFilledV2 } from './costSheetLibraryFilledV2.svg'
// import { ReactComponent as ItemsFilledV2 } from './itemsFilledV2.svg'
// import { ReactComponent as TransportersFilledV2 } from './transportersFilledV2.svg'
// import { ReactComponent as FabricLibraryFilledV2 } from './fabricLibraryFilledV2.svg'
// import { ReactComponent as MaterialLibraryFilledV2 } from './materialLibraryFilledV2.svg'
import { ReactComponent as CustomersFilledV2 } from './customersFilledV2.svg'
import { ReactComponent as SalesAgentsFilledV2 } from './salesAgentsFilledV2.svg'
// import { ReactComponent as SitesFilledV2 } from './sitesFilledV2.svg'

// // Administration icons
// import { ReactComponent as ManageRolesFilledV2 } from './manageRolesFilledV2.svg'
// import { ReactComponent as CreateRolesFilledV2 } from './createRolesFilledV2.svg'
// import { ReactComponent as GlobalConfigurationFilledV2 } from './globalConfigurationFilledV2.svg'
// import { ReactComponent as UserDataMappingFilledV2 } from './userDataMappingFilledV2.svg'
// import { ReactComponent as UsersFilledV2 } from './usersFilledV2.svg'
// import { ReactComponent as DataSyncFilledV2 } from './dataSyncFilledV2.svg'
// import { ReactComponent as AuditLogsFilledV2 } from './auditLogsFilledV2.svg'
// import { ReactComponent as ApiLogsFilledV2 } from './apiLogsFilledV2.svg'
// import { ReactComponent as SystemMailsFilledV2 } from './systemMailsFilledV2.svg'
// import { ReactComponent as RolesFilledV2 } from './rolesFilledV2.svg'

// // Reports and Analytics icons
// import { ReactComponent as ReplenishmentFilledV2 } from './replenishmentFilledV2.svg'
// import { ReactComponent as InventoryControlFilledV2 } from './inventoryControlFilledV2.svg'
// import { ReactComponent as SalesFilledV2 } from './salesFilledV2.svg'
import { ReactComponent as PurchaseFilledV2 } from './purchaseFilledV2.svg'
// import { ReactComponent as AccountingFilledV2 } from './accountingFilledV2.svg'
// import { ReactComponent as StockFilledV2 } from './stockFilledV2.svg'
// import { ReactComponent as ReportAnalyticsLogisticsFilledV2 } from './reportAnalyticsLogisticsFilledV2.svg'
// import { ReactComponent as ReportAnalyticsShipmentFilledV2 } from './reportAnalyticsShipmentFilledV2.svg'
import { ReactComponent as GrievanceFilled } from './grievanceFilled.svg'
import { ReactComponent as ReplenishmentSummaryV2 } from './replenishmentSummaryV2.svg'
import { ReactComponent as UserDepartmentMappingV2 } from './userDepartmentMappingV2.svg'

import { ReactComponent as ReplenishmentSummaryFilledV2 } from './replenishmentSummaryFilledV2.svg'


import { ReactComponent as PoQty } from './poQty.svg'
import { ReactComponent as GrcQty } from './grcQty.svg'
import { ReactComponent as AsnQty } from './asnQty.svg'
import { ReactComponent as CancelledQty } from './cancelledQty.svg'
import { ReactComponent as PendingQty } from './pendingQty.svg'
import { ReactComponent as SelectFile } from './selectFile.svg'
import { ReactComponent as PoAmountIgstGst } from './poAmountIgstGst.svg'
import { ReactComponent as VendorName } from './vendorName.svg'
import { ReactComponent as TypeOfBuying } from './typeOfBuying.svg'
import { ReactComponent as Termname } from './termname.svg'
import { ReactComponent as ShipmentRequestDate } from './shipmentRequestDate.svg'
import { ReactComponent as InvoiceNo } from './invoiceNo.svg'
import { ReactComponent as InvoiceDate } from './invoiceDate.svg'
import { ReactComponent as ArrowRightBlack } from './arrowRightBlack.svg'
import { ReactComponent as InvoiceAmount } from './invoiceAmount.svg'
import { ReactComponent as SearchIconBlack } from './searchIconBlack.svg'
import { ReactComponent as DocumentViewer } from './documentViewer.svg'
import { ReactComponent as NoSelectionFoundBlue } from './noSelectionFoundBlue.svg'
import { ReactComponent as StoreIcon } from './storeIcon.svg'

// module
import { ReactComponent as AllokatorWithLabel } from './allokatorWithLabel.svg'
import { ReactComponent as DigiProcWithLabel } from './digiProcWithLabel.svg'
import { ReactComponent as DigiSalesWithLabel } from './digiSalesWithLabel.svg'
import { ReactComponent as DigiVendWithLabel } from './digiVendWithLabel.svg'

import { ReactComponent as FromWarehouse } from './fromWarehouse.svg'
import { ReactComponent as ItemAssortment } from './itemAssortment.svg'
import { ReactComponent as Custom } from './custom.svg'
import { ReactComponent as RequirementIcon } from './requirementIcon.svg'
import { ReactComponent as AllocationIcon } from './allocationIcon.svg'

import { ReactComponent as AllokatorWithLabelFull } from './allokatorWithLabelFull.svg'
import { ReactComponent as DigiProcWithLabelFull } from './digiProcWithLabelFull.svg'
import { ReactComponent as DigiSalesWithLabelFull } from './digiSalesWithLabelFull.svg'
import { ReactComponent as DigiVendWithLabelFull } from './digiVendWithLabelFull.svg'


import { ReactComponent as DigiArsImage } from './digiArsImage.svg'
import { ReactComponent as DigiProcImage } from './digiProcImage.svg'
import { ReactComponent as DigiSalesImage } from './digiSalesImage.svg'
import { ReactComponent as DigiVendImage } from './digiVendImage.svg'
import { ReactComponent as HomeDashNoModuleImage } from './homeDashNoModuleImage.svg'

import { ReactComponent as DownloadIcon2 } from './downloadIcon2.svg'
import { ReactComponent as VendorProposedCost } from './vendorProposedCost.svg'

import { ReactComponent as Esg } from './esg.svg'
import { ReactComponent as WarningCircle } from './warningCircle.svg'
import { ReactComponent as Certifications } from './certifications.svg'
import { ReactComponent as IndustrySearch } from './industrySearch.svg'
import { ReactComponent as DocumentUpload } from './documentUpload.svg'
import { ReactComponent as Environment } from './environment.svg'
import { ReactComponent as Social } from './social.svg'

import { ReactComponent as DoubleQuote } from './doubleQuote.svg'
import { ReactComponent as EmailInBlueBox } from './emailInBlueBox.svg'
import { ReactComponent as TotalItems } from './totalItems.svg'
import { ReactComponent as TotalPo } from './totalPo.svg'
import { ReactComponent as RemainingQty } from './remainingQty.svg'
import { ReactComponent as MultipleUsers } from './multipleUsers.svg'
import { ReactComponent as FileShareIcon2 } from './fileShareIcon2.svg'
import { ReactComponent as WordFileIcon2 } from './wordFileIcon2.svg'
import { ReactComponent as PdfFileIcon2 } from './PdfFileIcon2.svg'

import { ReactComponent as FileIcon } from './fileIcon.svg'

import { ReactComponent as FacebookIcon } from './facebookIcon.svg'
import { ReactComponent as MailIcon } from './mailIcon.svg'
import { ReactComponent as LinkedInIcon } from './linkedInIcon.svg'
import { ReactComponent as TwitterIcon } from './twitterIcon.svg'
import { ReactComponent as TelegramIcon } from './telegramIcon.svg'
import { ReactComponent as InstaPaperIcon } from './instaPaperIcon.svg'
import { ReactComponent as WhatsappIcon } from './whatsappIcon.svg'
import { ReactComponent as ThreadsIcon } from './threadsIcon.svg'
import { ReactComponent as PinterestIcon } from './pinterestIcon.svg'

import { ReactComponent as FacebookIconFilled } from './facebookIconFilled.svg'
import { ReactComponent as MailIconFilled } from './mailIconFilled.svg'
import { ReactComponent as LinkedInIconFilled } from './linkedInIconFilled.svg'
import { ReactComponent as TwitterIconFilled } from './twitterIconFilled.svg'
import { ReactComponent as TelegramIconFilled } from './telegramIconFilled.svg'
import { ReactComponent as InstaPaperIconFilled } from './instaPaperIconFilled.svg'
import { ReactComponent as WhatsappIconFilled } from './whatsappIconFilled.svg'
import { ReactComponent as WechatIconFilled } from './WechatIconFilled.svg'
import { ReactComponent as ThreadsIconWhite } from './threadsIconWhite.svg'
import { ReactComponent as PinterestIconFilled } from './pinterestIconFilled.svg'
import { ReactComponent as UserPlusRound } from './userPlusRound.svg'
import { ReactComponent as ReportSubmitted } from './reportSubmitted.svg'
import { ReactComponent as InfoIconFilledYellow } from './infoIconFilledYellow.svg'
import { ReactComponent as NewOtb } from './newOtb.svg'
import { ReactComponent as OtbShifting } from './OtbShifting.svg'
import { ReactComponent as NewOtbDetails } from './newOtbDetails.svg'
import { ReactComponent as HoldOtb } from './holdOtb.svg'
import { ReactComponent as Note } from './note.svg'
import { ReactComponent as DateCalendar } from './dateCalendar.svg'
import { ReactComponent as Product } from './product.svg'
import { ReactComponent as RtvReason } from './rtvReason.svg'
import { ReactComponent as VendorStore } from './vendorStore.svg'
import { ReactComponent as Credit } from './credit.svg'
import { ReactComponent as Debit } from './debit.svg'
import { ReactComponent as GrievanceSummaryTotalGrievance } from './grievance_summary_total_grievance.svg'
import { ReactComponent as GrievanceSummaryOpenGrievance } from './grievance_summary_open_grievance.svg'
import { ReactComponent as GrievanceSummaryResolvedGrievance } from './grievance_summary_resolved.svg'
import { ReactComponent as GrievanceSummaryClosedGrievance } from './grievance_summary_closed.svg'
import { ReactComponent as GrievanceDashboardAvgResTime } from './grievance_dashboard_avg_res_time.svg'
import { ReactComponent as GrievanceSummaryInProgressGrievance } from './grievance_summary_in_progress.svg'
import { ReactComponent as BulkOtbShift } from './bulkOtbShift.svg'
import { ReactComponent as TNAConfig } from './tnaConfig.svg'
import { ReactComponent as ViewPlans } from './viewPlans.svg'
import { ReactComponent as SoftwareUpdate } from './softwareUpdate.svg'
import { ReactComponent as FileCodeCorner } from './fileCodeCorner.svg'
import { ReactComponent as TrfRequestFilled } from './trfRequestFilled.svg'
import { ReactComponent as TrfRequestIcon } from './trfRequest-icon.svg'
import { ReactComponent as Packaging } from './packaging.svg'
import { ReactComponent as Finishing } from './finishing.svg'
import { ReactComponent as Sewing } from './sewing.svg'
import { ReactComponent as Cutting } from './cutting.svg'
import { ReactComponent as PPS } from './pps.svg'
import { ReactComponent as FPT } from './fpt.svg'
import { ReactComponent as FabricNew } from './fabricNew.svg'
import { ReactComponent as BlueRocket } from './blueRocket.svg'
import { ReactComponent as HelloHand } from './helloHand.svg'
import { ReactComponent as Workspace } from './workspace.svg'
import { ReactComponent as Security } from './security.svg'
import { ReactComponent as Security2 } from './security2.svg'
import { ReactComponent as FileList } from './fileList.svg'
import { ReactComponent as ForcastSales } from './forcastSales.svg'
import { ReactComponent as ideal_inventory } from './ideal_inventory.svg'
import { ReactComponent as opening_stock } from './opening_stock.svg'
import { ReactComponent as pending_po_qty } from './pending_po_qty.svg'
import { ReactComponent as buying_plan } from './buying_plan.svg'
import { ReactComponent as RightArrowSquare } from './rightArrowSquare.svg'
import { ReactComponent as DefaultVideoIcon } from './defaultVideoIcon.svg';
import { ReactComponent as NoDataImg } from '../../assets/icons/default-document.svg';
import { ReactComponent as ArrowPrimaryTopRight } from './arrowPrimaryTopRight.svg';
import { ReactComponent as EditDatabase } from './EditDatabase.svg';

export default {
  buying_plan,
  pending_po_qty,
  opening_stock,
  ideal_inventory,
  ForcastSales,
  FabricNew,
  FPT,
  PPS,
  Cutting,
  Sewing,
  Finishing,
  Packaging,
  TrfRequestFilled,
  TrfRequestIcon,
  FileCodeCorner,
  NoDataFoundNew,
  SessionExpiredIcon,
  ZipAttack,
  PurchaseTerm,
  ModuleIcon,
  SubscriptionExpired,
  VendorHoldIcon,
  WifiNotFoundIcon,
  WifiEnabledIcon,
  UpgradSoft,
  ConfirmIdentityIcon,
  FlagWithCountryCodeIcon,
  VerifiedIcon,
  Battick,
  Dyeing,
  RightArrowThin,
  Embroidery,
  KaajButton,
  Printing,
  NoAnnouncementAlert,
  TestingFacilities,
  StepCompletedGreenTick,
  StepCompletedGreyTick,
  StepSeparationROd,
  Washing,
  YarnSpinning,
  OnSupplierPayroll,
  ThirdPartyContracts,
  VOStrongIcon,
  VOWeakIcon,
  VOModerateIcon,
  TimeLeftIcon,
  GCNotification,
  MOBILE,
  BOTH,
  PASSWORD,
  InfoIconNew,
  EscalationMatrix,
  Calender,
  OnboardingWarningIcon,
  PhoneIcon,
  FilePlusGreenIcon,
  TableComponentDownloadDocIcon,
  addGreen,
  closeRedNew,
  Configuration,
  ImgExpandIcon,
  RightArrowNewGreen,
  GreyHeart,
  RedYellowGreenDot,
  BlackHeart,
  SummaryTransferOrderIcon,
  NewDownloadIcon,
  DownloadIcon,
  WHBlueTick,
  EditNewIcon,
  InfoYellow,
  RightArrowGrey,
  BannerImageIcon,
  RightBigArrow,
  CatalogueImageThumbnail,
  AnnouncementGreenAlert,
  AnnouncementAlert,
  UnapproveCircleTick,
  ApproveCircleTick,
  GCUploadIcon,
  FileList,
  FashionAccessories,
  EnterInputIcon,
  HomeFurnishing,
  ReadMoreAttachIcon,
  Fabric,
  Apparels,
  InfoYellow,
  UnapproveCircleTick,
  ApproveCircleTick,
  FileClock,
  GCUploadIcon,
  DocumentMediaIcon,
  SupplierBasicDetailsIcon,
  FinanceIcon,
  ScheduledJObIcon,
  ReportDownloadIcon,
  GRCSuccessIcon,
  NewCopyIcon,
  FilterPinned,
  GreenDotActive,
  GreyDotInactive,
  Threedot,
  TGImgIcon,
  TGVideoIcon,
  TGPdfIcon,
  RightArrowExpand,
  RightArrowExpand2,
  ArrowReviewSvg,
  Transpose,
  DelayIcon,
  TGEditIcon,
  GCFilterIcon,
  FilePlusIcon,
  ImageThumbnail,
  PdfDownloadDocumentIcon,
  TableConfigDefault,
  CompliancesIcon,
  GCExplanationIon,
  SystemMaintenance,
  Announcement,
  Training,
  DropdownField,
  ReplenishmentSetting,
  BarcodeProfile,
  DangerIcon,
  OrganizationData,
  BlueDownloadIcon,
  DataSetting,
  ExpFilterIcon,
  MultiLevelApproval,
  FormSetting,
  WorkflowSetting,
  GeneralSetting,
  BoxThree,
  FileTick,
  DataManagement,
  APIIntegration,
  TableHeader,
  DocumentFormat,
  InfoWhiteIcon,
  ProcChooseFileIcon,
  DraftFileIcon,
  ProcChooseFileIcon,
  ImageThumbnail,
  Check,
  FileBadge,
  UserIn,
  UserOut,
  PdfDownloadDocumentIcon,
  GstIcon,
  LocationIcon,
  DryClean,
  CopyPenIcon,
  TumbleDry,
  Iron,
  Bleach,
  EmptyBoxNew,
  CommentSvg,
  NoCommentSvg,
  TnaIcon,
  CommentSvg,
  BlueInfoIcon,
  NoCommentSvg,
  UnapprovedTag,
  NoLogoIcon,
  OrgLogoGeneric,
  RemarkCancelIocn,
  CommentSvg,
  NoCommentSvg,
  UnapprovedTag,
  WebIcon,
  ExpandedConfigTableHeader,
  UnexpandedConfigTableHeader,
  HandDollarSvg,
  CircleTickFilledWhite,
  PasswordCheckCircle,
  DataExportFileIconNew,
  ImgNextIcon,
  ImageIcon,
  ImgPrevIcon,
  ProfileOrgIcon,
  ProfileSettingIcon,
  EmailOTPIcon,
  MobileOTPIcon,
  CopyRightIcon,
  NoScanIcon,
  MoverIcon,
  LoginStripIcon,
  PackageProducts,
  SiteMappingData,
  VendorMappingData,
  ManagementData,
  UserIcon,
  DataMappingIcon,
  LogoutIcon,
  ProfileFaceIcon,
  PasswordLockIcon,
  SignInBadgeIcon,
  PasswordEyeIcon,
  PasswordEyeIconSmall,
  PasswordEyeDisabledIcon,
  EmailTranscriptIcon,
  AddComentEnterIcon,
  SupportIcon,
  SupplymintRIcon,
  ExportToExcel,
  EmailReport,
  SearchIconDark,
  ExpandedTableIcon,
  NotExpandedTableIcon,
  ScanBarcodeIcon,
  ChatIconTableComponent,
  PendingQcIcon,
  DownloadDocumentsIcon,
  SettingIcon,
  DragDropIcon,
  ArrowUpIcon,
  ArsDraft,
  ArsHold,
  SummaryInfoIcon,
  VendorRedirectIconWhite,
  DownloadExcelTemplateGreenIcon,
  UploadExcelIcon,
  CreateNewTicketIcon,
  HelpNewTicket,
  DownloadContentIcon,
  FileShareIcon,
  NoJobsFound,
  SortingIcon,
  BreadcrumbSortingIcon,
  ArsDFailedIcon,
  ArsRejectedIcon,
  ArsApprovedIcon,
  ArsPendindIcon,
  GreenTick,
  PinnedIcon,
  UnpinnedIcon,
  VendorRedirectIcon,
  EditIcon,
  AddMappingPlusIcon,
  EmailResendIcon,
  WarningYellowIcon,
  EyeIcon,
  RefreshIcon,
  LogIcon,
  RightArrow1,
  RightArrow2,
  LogSearchIcon,
  JobRunSuccessIcon,
  JobRunFailedIcon,
  AutoPurchaseReplenishmentIcon,
  AutoPurchaseReplenishmentIcon2,
  StoreReplenishmentIcon,
  StoreReplenishmentIcon2,
  WarehouseIcon,
  WarehouseIcon2,
  WarehouseIconBlue2,
  StoreReplenishmentIconBlue2,
  AutoPurchaseReplenishmentIconBlue2,
  DeleteIcon,
  AddIcon,
  PlusIcon,
  PlusIconBlack,
  NextIcon,
  PrevIcon,
  AddGreenIcon,
  DownloadPdf,
  DownloadPdf1,
  CustomUploadSvg1,
  AdhocSvg1,
  CircleTick,
  DownloadWhiteIcon,
  AttachFileBlueIcon,
  TriggerHandIcon,
  RedDotWatchIcon,
  GreenDotWatchIcon,
  NewSupplymintLogo,
  VendorSupplymintLogo,
  CustomerSupplymintLogo,
  MenuHomeIcon,
  DigiArsMenuIcon,
  DigiVendorMenuIcon,
  EntCatalogueMenuIcon,
  SalesManagementMenuIcon,
  MasterDataMenuIcon,
  AdminIconMenuIcon,
  VendorCatalogueMenuIcon,
  InvoiceManagementMenuIcon,
  DigiProcMenuIcon,
  ReportsAnalyticsMenuIcon,
  SuperAdminMenuIcon,
  DigiArsMenuIconFilled,
  DigiVendorMenuIconFilled,
  EntCatalogueMenuIconFilled,
  SalesManagementMenuIconFilled,
  MasterDataMenuIconFilled,
  AdminIconMenuIconFilled,
  InvoiceManagementMenuIconFilled,
  SuperAdminMenuIconFilled,
  DigiProcMenuIconFilled,
  ReportsAnalyticsMenuIconFilled,
  RightArrowMenuIcon,
  GlobalSearchIcon,
  ModalCloseIcon,
  DeselectedItemIcon,
  SelectedItemIcon,
  GlobalSearchArrowIcon,
  HeaderHelpMenuIcon,
  HeaderNotificationsIcon,
  HeaderDataExportIcon,
  DataExportFileIcon,
  DataExportDownloadActiveIcon,
  DataExportDownloadDisabledIcon,
  DataExportCancelActiveIcon,
  DataExportCancelDisabledIcon,
  NotificationMenuIcon,
  ProfileLogoutIcon,
  BackArrowIcon,
  BackArrowIcon2,
  CopyIcon,
  CopyIconWhite,
  CrossIcon,
  SiteMappingSVG1,
  SearchIcon,
  NewSearchIcon,
  NoHeader,
  ClearSearch,
  DownArrowNew,
  DownArrowWhite,
  DownArrowFilled,
  DownArrowFilledGrey,
  ConfirmationModalImg,
  NoDataFound,
  NewNoDataFound,
  UploadImg,
  BCRightArrow,
  ReloadIcon,
  TickGreenIcon,
  CrossRedIcon,
  RupeeIcon,
  DownArrow,
  NoImgFound,
  BagIcon,
  ListViewIcon,
  GridViewIcon,
  NewTicket,
  AllTicket,
  HelpIcon,
  VideoIcon,
  KeyboardShortcut,
  replayAppTour,
  SupportDoc,
  BagEdit,
  ErrorIcon,
  UploadIcon,
  CaptureIcon,
  LeftArrow,
  RightArrowBlue,
  CreatePlusIcon,
  Minus,
  MinusIconBlack,
  Plus,
  NoProductFound,
  Tick,
  MatrixView,
  DeleteNew,
  CustomerIcon,
  DeliveryLocation,
  ScanIcon,
  HeaderDeleteIcon,
  SettingIconNew,
  TableEyeIcon,
  TableEditIcon,
  Remark,
  CollapesIcon,
  ProcAddIcon,
  ProcAddRow,
  ProcMoreBtn,
  ProcDeleteIcon,
  ProcCopyIcon,
  ErrorWarning,
  ExpandRow,
  DownArrowSmall,
  RightArrowWhite,
  InfoIcon,
  TGRedirectIcon,
  GreenCircledGreenTick,
  WorkLogsIcon,
  DefaultReportIcon,
  SendIcon,
  WechatIcon,
  DummyQRCode,
  DesktopWarningIcon,
  MacIcon,
  WindowsIcon,
  PlaneIconYellow,
  CelebrationPopperIcon,
  NewPdfIcon,
  NoPageAvailable,
  ExcelFileIcon,
  WordFileIcon,
  ChineseLangIcon,
  WechatIcon2,
  KeyIcon,
  UsersLimitReached,
  SaveFilterWarning,
  InfiniteLoop,
  FabricIcon,
  FeedbackIcon,
  thirdPartyIcon,
  SiteLimitReached,
  SuccessIcon,
  MoneyRating1,
  MoneyRating2,
  MoneyRating3,
  MoneyRating4,
  MoneyRating5,
  PdfFileIcon,
  CommentIcon,
  CelebrationColorfulPopper,
  InfiniteLoop,
  ExcelUploadTemplate,
  EyeIcon2,
  productImagesCollection,
  wallet,
  UploadIconBlue,
  ErrorIconNew,
  UploadIconNew,
  SortingUpArrow,
  PlayIcon,
  HomeIcon,
  HomeIconFilled,
  EmailReceived,
  EmailSent,
  Star,
  RatingEmoji1,
  RatingEmoji2,
  RatingEmoji3,
  RatingEmoji4,
  RatingEmoji5,
  ThumbsUp,
  ThumbsDown,
  Collapse2,
  Expand2,
  FilterCheck,
  Upgrade,
  NoDocument,
  CostsheetError,
  SupplymintGrey,
  FabricNotFound,
  CheckedGreen,
  NewSearchIconWhite,

  // New Sidebar Icons
  DashboardMenuV2,
  ProductsV2,
  SalesIndentV2,
  PurchaseOrdersV2,
  ShipmentsV2,
  LogisticsV2,
  GrcV2,
  LedgerV2,
  ReportsAndAnalyticsV2,

  MappingsV2,
  AssortmentV2,
  RunReplenishmentV2,
  PlanningOrdersV2,
  AdhocRequestsV2,
  HistoryV2,

  QualityCheckV2,
  AsnV2,
  FinanceV2,
  ManageV2,

  LrProcessingV2,
  GrcStatusV2,
  SaleOrdersV2,
  DeliveryChallanV2,
  PricelistV2,

  AdministrationV2,
  MasterDataV2,

  // Master Data icons
  AgentsV2,
  SetV2,
  VendorsV2,
  MailingListV2,
  CostSheetLibraryV2,
  ItemsV2,
  TransportersV2,
  FabricLibraryV2,
  MaterialLibraryV2,
  CustomersV2,
  SalesAgentsV2,
  SitesV2,

  // Administration icons
  ManageRolesV2,
  CreateRolesV2,
  GlobalConfigurationV2,
  UserDataMappingV2,
  UsersV2,
  DataSyncV2,
  AuditLogsV2,
  ApiLogsV2,
  SystemMailsV2,
  RolesV2,

  // Reports and Analytics Icons
  ReplenishmentV2,
  InventoryControlV2,
  AdminV2,
  SalesV2,
  PurchaseV2,
  AccountingV2,
  StockV2,
  ReportAnalyticsLogisticsV2,
  ReportAnalyticsShipmentV2,
  ApplicationsSemiFill,
  DropdownSettings,
  DigiprocV2,
  AllokatorV2,
  DigisalesV2,

  Grievance,

  // filled state
  DashboardMenuFilledV2,
  ProductsFilledV2,
  SalesIndentFilledV2,
  PurchaseOrdersFilledV2,
  ShipmentsFilledV2,
  LogisticsFilledV2,
  GrcFilledV2,
  LedgerFilledV2,
  ReportsAndAnalyticsFilledV2,
  MappingsFilledV2,
  AssortmentFilledV2,
  RunReplenishmentFilledV2,
  PlanningOrdersFilledV2,
  AdhocRequestsFilledV2,
  HistoryFilledV2,
  QualityCheckFilledV2,
  AsnFilledV2,
  FinanceFilledV2,
  ManageFilledV2,
  LrProcessingFilledV2,
  GrcStatusFilledV2,
  SaleOrdersFilledV2,
  DeliveryChallanFilledV2,
  PricelistFilledV2,

  CustomersFilledV2,
  SalesAgentsFilledV2,
  PurchaseFilledV2,
  GrievanceFilled,

  VendorIcon,
  PoAmount,
  DropdownSettings,
  PoQty,
  GrcQty,
  AsnQty,
  CancelledQty,
  PendingQty,
  PoAmountIgstGst,
  VendorName,
  TypeOfBuying,
  Termname,
  ShipmentRequestDate,
  InvoiceNo,
  InvoiceDate,
  ArrowRightBlack,
  InvoiceAmount,
  SearchIconBlack,
  DocumentViewer,
  AllokatorWithLabel,
  DigiProcWithLabel,
  DigiSalesWithLabel,
  DigiVendWithLabel,
  NoSelectionFoundBlue,
  StoreIcon,

  FromWarehouse,
  ItemAssortment,
  Custom,
  WarehouseIconClipped,
  WarehouseIconBlueClipped,
  StoreReplenishmentIconClipped,
  StoreReplenishmentIconBlueClipped,
  AutoPurcahseReplenishmentIconClipped,
  AutoPurcahseReplenishmentIconBlueClipped,
  RequirementIcon,
  AllocationIcon,
  DigiArsImage,
  DigiProcImage,
  DigiSalesImage,
  DigiVendImage,
  AllokatorWithLabelFull,
  DigiProcWithLabelFull,
  DigiSalesWithLabelFull,
  DigiVendWithLabelFull,

  DownloadIcon2,
  StoreIcon,
  VendorProposedCost,
  Esg,
  WarningCircle,
  Certifications,
  IndustrySearch,
  DocumentUpload,
  Environment,
  Social,
  DoubleQuote,
  EmailInBlueBox,
  HomeDashNoModuleImage,
  TotalItems,
  TotalPo,
  RemainingQty,
  FileShareIcon2,
  WordFileIcon2,
  PdfFileIcon2,
  ExcelFileIcon2,
  FileIcon,
  FacebookIcon,
  MailIcon,
  LinkedInIcon,
  TwitterIcon,
  TelegramIcon,
  InstaPaperIcon,
  WhatsappIcon,
  ThreadsIcon,
  PinterestIcon,
  FacebookIconFilled,
  MailIconFilled,
  LinkedInIconFilled,
  TwitterIconFilled,
  TelegramIconFilled,
  InstaPaperIconFilled,
  WhatsappIconFilled,
  WechatIconFilled,
  ThreadsIconWhite,
  PinterestIconFilled,
  UserPlusRound,
  WarningRedIcon,
  MultipleUsers,
  ReportSubmitted,
  InfoIconFilledYellow,
  NewOtb,
  OtbShifting,
  NewOtbDetails,
  HoldOtb,
  Note,
  DateCalendar,
  Product,
  RtvReason,
  SelectFile,
  VendorStore,
  Credit,
  Debit,
  ItemMasterConfig,
  SalesForecastV2,
  SalesForecastFilledV2,
  GrievanceSummaryTotalGrievance,
  GrievanceSummaryOpenGrievance,
  GrievanceSummaryResolvedGrievance,
  GrievanceSummaryClosedGrievance,
  GrievanceDashboardAvgResTime,
  GrievanceSummaryInProgressGrievance,
  BulkOtbShift,
  TNAConfig,
  ServiceOrderV2,
  ServiceOrderFilledV2,
  ReplenishmentSummaryV2,
  UserDepartmentMappingV2,
  ReplenishmentSummaryFilledV2,
  ViewPlans,
  SoftwareUpdate,
  BlueRocket,
  HelloHand,
  Workspace,
  Security,
  Security2,
  RightArrowSquare,
  DefaultVideoIcon,
  NoDataImg,
  ArrowPrimaryTopRight,
  EditDatabase
};
